import { PaymentsApi } from "@/api/payments";
import {
  DataProvider,
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  Identifier,
  RaRecord,
} from "react-admin";
import { ResourceName } from "../react-admin.util";

const dataProvider: DataProvider = {
  getList: async <RecordType extends RaRecord = RaRecord>(
    _resource: string,
    params: GetListParams,
  ): Promise<GetListResult<RecordType>> => {
    const { pagination, filter, sort } = params;
    const result = await PaymentsApi.list({
      ...filter,
      page: pagination?.page,
      perPage: pagination?.perPage,
      sortBy: sort?.field,
      sortDirection: sort?.order
        ? (sort.order.toLowerCase() as "asc" | "desc")
        : undefined,
    });
    return {
      data: result.data.map((row) => ({
        ...row,
        id: row.orderId as Identifier,
      })) as unknown as RecordType[],
      total: result.meta.total,
    };
  },
  getOne: async <RecordType extends RaRecord = RaRecord>(
    _resource: string,
    params: GetOneParams,
  ): Promise<GetOneResult<RecordType>> => {
    const detail = await PaymentsApi.getDetail({
      orderId: String(params.id),
    });
    return {
      data: { ...detail, id: detail.orderId as Identifier } as unknown as RecordType,
    };
  },
  getMany: () => Promise.resolve({ data: [] }),
  getManyReference: () => Promise.resolve({ data: [], total: 0 }),
  create: () => Promise.reject(new Error("not supported")),
  update: () => Promise.reject(new Error("not supported")),
  updateMany: () => Promise.reject(new Error("not supported")),
  delete: () => Promise.reject(new Error("not supported")),
  deleteMany: () => Promise.reject(new Error("not supported")),
};

export const userPurchasesResourceProvider = {
  resource: ResourceName.USER_PURCHASES,
  dataProvider,
};
